<div *ngIf="isOpen"
    class="container-sticky container d-flex justify-content-between align-items-center {{setTypeSticky(block.tipologia_banner)}} p-3">
    <div class="d-flex align-items-center">
        <div *ngIf="block.tipologia_banner" class="ps-3 pe-4">
            <img loading="lazy" *ngIf="block.tipologia_banner === 'Successo'" src="./assets/images/check.svg" alt="icon">
            <img loading="lazy" *ngIf="block.tipologia_banner === 'Attenzione'" src="./assets/images/alert_yellow.svg" alt="icon">
            <img loading="lazy" *ngIf="block.tipologia_banner === 'Urgente'" src="./assets/images/alert_red.svg" alt="icon">
        </div>
        <div class="container-sticky__box-text">
            <h3 *ngIf="block.titolo" class="container-sticky__box-text__title ls-h3-item-title" [innerHTML]="block.titolo"></h3>
            <p *ngIf="block.testo_formattato" class="container-sticky__box-text__description ls-p m-0" [innerHTML]="block.testo_formattato | safeHtml"></p>
        </div>
    </div>
    <div class="container-sticky__box-button pe-3 ps-4">
        <a *ngIf="!isLinkEsternal" [routerLink]="navigationService.splitUrlRouterLink(block.link_cta.url).path" [queryParams]="navigationService.splitUrlRouterLink(block.link_cta.url).queryParams">
            <button class="btn-custom btn-light text-uppercase ls-label-medium-semibold text-brand-10" (click)="closeSticky()" [innerHTML]="block.label_cta"></button>
        </a>
        <a class="btn-custom btn-light text-uppercase ls-label-medium-semibold text-brand-10" *ngIf="isLinkEsternal" [href]="block.link_cta.url" target="_blank"
            [innerHTML]="block.label_cta"></a>
    </div>
</div>